import {
	BookingTime,
	BookingSlot,
	Timeslot,
} from '../../../model/types';
import { formatTime } from 'shared/lib/time';
import { Option } from 'shared/types';

export const extractBookingTimes = (
	bookingSlots: BookingSlot[],
): BookingTime[] => {
	const bookingTimes: BookingTime[] = [];
	bookingSlots.map(bookingSlot => {
		const hasSeats = bookingSlot.has_seats;
		const isExact = bookingSlot.is_exact;

		if (!bookingSlot.slot || !bookingSlot.slot.dt_start) {
			return false;
		}

		const slot = bookingSlot.slot;
		const formattedTime = formatTime({ time: slot.dt_start });
		if (formattedTime) {
			bookingTimes.push({
				time: formattedTime.time,
				date: slot.dt_start,
				duration: slot.base_duration,
				hasSeats,
				isExact,
				slot,
			});
		}
	});

	return bookingTimes;
};

export const createTimesOptions = (timeslots: Timeslot[]): Option[] => {
	const times: Option[] = [];
	timeslots.map(timeslot => {
		const formattedTime = formatTime({ time: timeslot.dt_start });
		if (formattedTime) {
			times.push({
				value: formattedTime.time,
				label: formattedTime.time,
			});
		}
	});

	return times;
};
